import { defineMessages } from 'react-intl';

export default defineMessages({
  dateReceiptRequestField: {
    id:
      'civil_proceeding_modal.basic_information.date_receipt_request_field.title',
  },
  hearingDateField: {
    id: 'civil_proceeding_modal.basic_information.date_hearing_field.title',
  },
  courtFile: {
    id:
      'legal_proceeding_page.judgement_add.procedure_information.court_file.title',
  },
  victims: {
    id:
      'legal_proceeding_page.judgement_add.civil_party.civil_party_recap.victims',
  },
  vehicles: {
    id:
      'legal_proceeding_page.judgement_add.civil_party.civil_party_recap.vehicles',
  },
  documents: {
    id:
      'legal_proceeding_page.judgement_add.civil_party.civil_party_recap.documents',
  },
  judgementAddPronouncingTitle: {
    id: 'legal_proceeding_page.judgement_add.judgement_add_pronouncing.title',
  },
  request: {
    id: 'legal_proceeding_page.request',
  },
  recapTabTitle: {
    id: 'legal_proceeding_page.recap_tab_title',
  },
  judgementAddTabTitle: {
    id: 'legal_proceeding_page.judgement_add_tab_title',
  },
  expertReportTabTitle: {
    id: 'legal_proceeding_page.expert_report_tab_title',
  },
  expertReportConsultTabTitle: {
    id: 'legal_proceeding_page.expert_report_consult_tab_title',
  },
  judgementOnMeritsTabTitle: {
    id: 'legal_proceeding_page.judgement_on_merits_tab_title',
  },
  judgementOnMeritsLabelTitle: {
    id: 'legal_proceeding_page.judgement_on_merits_label_title',
  },
  appealOnMeritsLabelTitle: {
    id: 'legal_proceeding_page.appeal_on_merits_label_title',
  },
  JudgementAppealTabTitle: {
    id: 'legal_proceeding_page.judgement_appeal_tab_title',
  },
  correctionalJudgementTitle: {
    id: 'legal_proceeding_page.correctional_judgement_title',
  },
  judgementOnMeritsInfo: {
    id: 'legal_proceeding_page.judgement_on_merits_info_title',
  },
  rejectedTitle: {
    id: 'legal_proceeding_page_info_rejected_title',
  },
  judgementOnMeritsAdditionalInfo: {
    id: 'legal_proceeding_page.judgement_on_merits_additional_info_title',
  },
  deceasedVictims: {
    id: 'legal_proceeding_page.judgement_on_merits_deceased_victims_title',
  },
  judgementDate: {
    id: 'legal_proceeding_page.judgement_add.judgement_on_merits.date',
  },
  judgementDateError: {
    id: 'legal_proceeding_page.judgement_add.judgement_on_merits.date_error',
  },
  condamnationFieldTitle: {
    id: 'legal_proceeding_page.judgement_on_merits.condamnation_field',
  },
  yes: {
    id: 'legal_proceeding_page.judgement_add.procedure_information.yes',
  },
  managerDecision: {
    id: 'manager.decision.title',
  },
  damageAffectedByTheProcedure: {
    id: 'civil_proceeding_modal.damage_affected_by_the_procedure',
  },
  no: {
    id: 'legal_proceeding_page.judgement_add.procedure_information.no',
  },
  judgementOnMeritsNumberFieldTitle: {
    id: 'legal_proceeding_page.judgement_on_merits.number_field',
  },
  audience: {
    id: 'civil_proceeding_modal.audience',
  },
  judgementOnMeritsDepensFieldTitle: {
    id: 'legal_proceeding_page.judgement_on_merits.depens_field',
  },
  judgementOnMeritsCostFieldTitle: {
    id: 'legal_proceeding_page.judgement_on_merits.cost_field',
  },
  judgementOnMeritsCommentaryFieldTitle: {
    id: 'legal_proceeding_page.judgement_on_merits.commentary_field',
  },
  injuredVictim: {
    id: 'legal_proceeding_page.judgement_on_merits_injured_victims_title',
  },
  judgementOnMeritsDefenseToExecutionFieldTitle: {
    id: 'legal_proceeding_page.judgement_on_merits.defense_to_execution_field',
  },
  judgementOnMeritsDifficultyToExecutionFieldTitle: {
    id:
      'legal_proceeding_page.judgement_on_merits.difficulty_to_execution_field',
  },
  judgementOnMeritsLawyerOpinionFieldTitle: {
    id: 'legal_proceeding_page.judgement_on_merits.lawyer_opinion_field',
  },
  judgementOnMeritsIddFieldTitle: {
    id: 'legal_proceeding_page.judgement_on_merits.idd_field',
  },
  judgementInfoDate: {
    id: 'legal_proceeding_page.judgement_add.judgement_on_merits_info.date',
  },
  damageAmountFieldTitle: {
    id: 'legal_proceeding_page.judgement_on_merits.damage_amount_field',
  },
  compensationFieldTitle: {
    id: 'legal_proceeding_page.judgement_on_merits.compensation_field',
  },
  provisionalExecution: {
    id: 'legal_proceeding_page.judgement_on_merits.provisional_enforcement',
  },
  revenueFieldTitle: {
    id: 'legal_proceeding_page.judgement_on_merits.revenue_field',
  },
  judiciaryAmount: {
    id: 'legal_proceeding_page.judgement_on_merits.judiciary_amount_field',
  },
  calculatedCompensationFieldTitle: {
    id:
      'legal_proceeding_page.judgement_on_merits.calculated_compensation_field',
  },
  provisionalExecutionFieldTitle: {
    id: 'legal_proceeding_page.judgement_on_merits.provisional_execution_field',
  },
  calculatedRevenueFieldTitle: {
    id: 'legal_proceeding_page.judgement_on_merits.calculated_revenue_field',
  },
  backButton: {
    id: 'legal_proceeding_page.validation_buttons.back_button',
  },
  validButton: {
    id: 'legal_proceeding_page.validation_buttons.validate',
  },
  successDialogTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add.success_dialog.title',
  },
  successDialogPrimaryButtonTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add.success_dialog.primary_button_title',
  },
  successDialogSecondaryButtonTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add.success_dialog.secondary_button_title',
  },
  successDialogPrimaryButtonTitleJdd: {
    id: 'success_dialog.fee_note',
  },
  doNotGenerateFeeNote: {
    id: 'success_dialog.do_not_generate_fee_note',
  },
  affectationProcedure: {
    id: 'court_manager.civil_proceeding_affectation',
  },
  judgementAdd: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd',
  },
  judgementCivil: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementCivil',
  },
  judgementCivilOrNonCompensation: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementCivil_nonCompensation',
  },
  judgementCivilRecap: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementCivil.recap',
  },
  mechanicalExpertise: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.mechanicalExpertise',
  },
  medicalExpertise: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.medicalExpertise',
  },
  accountingExpertise: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.accountingExpertise',
  },
  addButton: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.addButton',
  },
  addSuedParty: {
    id: 'legal_proceeding_page.correctional_judgement_add_bloc_title',
  },
  cancelButton: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.cancelButton',
  },
  saveButton: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.saveButton',
  },
  editButton: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.updateButton',
  },
  goBackButton: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.goBackButton',
  },
  validateWithoutContestation: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.validateButton_withoutContestation',
  },
  validateButton: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.validateButton',
  },
  challenge: {
    id: 'legal_proceeding_page.judgement_on_merits.recap.title.challenge',
  },
  challenged: {
    id: 'legal_proceeding_page.judgement_on_merits.recap.title.challenged',
  },
  courtManagerValidationDialogSuccessMessage: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.confirmation_dialog.success_message',
  },
  sharedResponsability: {
    id: 'legal_proceeding_page.judgement_on_merits_shared_responsibility_title',
  },
  suedParties: {
    id: 'legal_proceeding_page.judgement_on_merits_add_sued_party_title',
  },
  suedPartySelect: {
    id: 'legal_proceeding_page.judgement_on_merits_add_sued_party_select_title',
  },
  suedPartyTitle: {
    id: 'legal_proceeding_page.judgement_on_merits_sued_party_title',
  },
  delete: {
    id: 'preopening_page.victim_delete_button_title',
  },
  responsibiltySharePercentage: {
    id: 'preopening_page.claim_circumstances.responsibilty_percentage',
  },
  calculatedRevenue: {
    id: 'legal_proceeding_page.judgement_appeal.appeal_civil.compensation',
  },
  opposingLawyerField: {
    id: 'civil_proceeding_modal.opposingLawyer',
  },
  circomscriptionField: {
    id: 'civil_proceeding_modal.circomscription',
  },
  jurisdictionField: {
    id: 'civil_proceeding_modal.percentage_juridiction',
  },
  assignedLawyerTitle: {
    id: 'claim_with_not_indexed_PV.is_lawyer_assigned',
  },
  updatedRequest: {
    id: 'toast.success.requestUpdated.title',
  },
  hearingDateTitle: {
    id: 'civil_proceeding_modal.basic_information.date_hearing_field.title',
  },
  town: {
    id: 'preopening_page.victim.city',
  },
  assignedLawyer: {
    id: 'claim_with_not_indexed_PV.is_lawyer_assigned',
  },
  supportingDocuments: {
    id: 'recap_page.documents_bloc_title',
  },
  otherProperties: {
    id: 'civil_proceeding_modal.other-properties',
  },
  judiciaryProcessTabTitle: {
    id: 'first_tab.judiciary_process',
  },
  contestationButton: {
    id: 'court_manager_legal_proceedings_page.expert_report.decision.contest',
  },
  contestationInfos: {
    id: 'legal_proceeding_page.contestation.infos',
  },
  contestationLawyerOpinion: {
    id: 'legal_proceeding_page.contestation.lawyerOpinion',
  },
  contestationOwner: {
    id: 'legal_proceeding_page.contestation.owner',
  },
  contestationAgainst: {
    id: 'legal_proceeding_page.contestation.against',
  },
  contestationVictimes: {
    id: 'legal_proceeding_page.contestation.victimes',
  },
  contestationVehicules: {
    id: 'legal_proceeding_page.contestation.vehicules',
  },
  contestationUploadButton: {
    id: 'claim_with_not_indexed_PV_drawer.download',
  },
  uploadRequestDocumentTitle: {
    id: 'legal_proceeding_page.contestation.requestDocument',
  },
  uploadOppositionActDocumentTitle: {
    id: 'legal_proceeding_page.contestation.oppositionActDocument',
  },
  uploadDocumentMaxSize: {
    id: 'legal_proceeding_page.contestation.DocumentMaxSize',
  },
  contestationAudienceDate: {
    id: 'legal_proceeding_page.contestation.audienceDate',
  },
  contestationDrawerTitle: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_drawer_title',
  },
  judgementOnMeritsContestationType: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_drawer_type',
  },
  judgementOnMeritsContestationWithdrawalReason: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_drawer_withdrawal_reason',
  },
  judgementOnMeritsContestationBeneficiaries: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_drawer_beneficiaries',
  },
  contestationDecision: {
    id: 'legal_proceeding_page.contestation.decision',
  },
  uploadOppositionDecisionDocumentTitle: {
    id: 'legal_proceeding_page.contestation.oppositionDecisionDocument',
  },
  judgementOnMeritsContestationOwner: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_drawer_owner',
  },
  judgementOnMeritsContestationAgainst: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_drawer_against',
  },
  judgementOnMeritsContestationCommentary: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_drawer_commentary',
  },
  judgementOnMeritsContestationDifficultyExecution: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_difficulty_execution',
  },
  judgementOnMeritsContestationDefenseExecution: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_defense_execution',
  },
  judgementOnMeritsContestationSuccessCallback: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_drawer_success',
  },
  validateRequiredField: {
    id: 'validate.required_field',
  },
  managerDecisionTitle: {
    id: 'manager.decision.title',
  },
  contest: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.contestButton',
  },
  contestationType: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.contestationType',
  },
  lawyercontestationType: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.lawyer.contestationType',
  },
  reject: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementOnMerits.reject',
  },
  contestationOpposingParties: {
    id: 'legal_proceeding_page.contestation.opposingParties',
  },
  contestationVictims: {
    id: 'legal_proceeding_page.contestation.victims',
  },
  decision: {
    id: 'legal_proceedings_page.judgement_on_merits.decision.title',
  },
  newAmount: {
    id: 'new_amount',
  },
  requestValidation: {
    id: 'judiciary_process.request_validation',
  },
  rejectButton: {
    id: 'manager_recap_page_reject_button.title',
  },
  rejectDecision: {
    id: 'judiciary_process_recap.reject_decision',
  },
  validationDecision: {
    id: 'judiciary_process_recap.validation_decision',
  },
  supportDocument: {
    id:
      'legal_proceeding_page.judgement_add.civil_party.civil_party_recap.support_document',
  },
  caduc: {
    id: 'legal_proceeding_page.caduc',
  },
  jomToastSuccess: {
    id: 'judgement_on_merits.success',
  },
  fullname: {
    id: 'preopening_page.beneficiary_fullname',
  },
  age: {
    id: 'preopening_page.beneficiary_age',
  },
  qualityBeneficiary: {
    id: 'preopening_page.victim.qualityBeneficiary',
  },
  victimFrais: {
    id: 'preopening_page.victim.frais',
  },
  rejectedMessage: {
    id: 'legal_proceeding_page.judgement_on_merits_info_title',
  },
  appealAddTitle: {
    id: 'court_manager_legal_proceedings_page.appeal_add_tab.title',
  },
  appealExpertReportTitle: {
    id: 'court_manager_legal_proceedings_page.appeal_expert_report_tab.title',
  },
  appealOnMeritsTitle: {
    id: 'court_manager_legal_proceedings_page.appeal_on_merits_tab.title',
  },
  lawyerFirmReferenceDialogSuccessMessage: {
    id: 'legal_proceeding_page.update_firm_reference_dialog_info_success',
  },
  lawyerFirmReferenceDialogSuccessFeeNoteMessage: {
    id:
      'legal_proceeding_page.update_firm_reference_dialog_info_fee_note_success',
  },
  lawyerFirmReferenceDialogValidate: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.refusal_popin.validate',
  },
  lawyerFirmReferenceDialogCancel: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.refusal_popin.cancel',
  },
  lawyerFirmReferenceDialogTitle: {
    id: 'legal_proceeding_page.update_firm_reference_dialog_info_title',
  },
  lawyerFirmReferenceDialogFeeNoteTitle: {
    id:
      'legal_proceeding_page.update_firm_reference_dialog_fee_note_info_title',
  },
  lawyerFirmReferenceDialogLabel: {
    id: 'legal_proceeding_page.update_firm_reference_dialog_label',
  },
  lawyerFirmReferenceUpdateMessage: {
    id: 'legal_proceeding_page.check_firm_reference_info',
  },
  lawyerFirmReferenceEditMessage: {
    id: 'legal_proceeding_page.check_update_firm_reference_info',
  },
  successToastTitle: {
    id: 'judgement_add_document.success',
  },
  successContestationToastTitle: {
    id: 'contestation_validation.success',
  },
  successContestationUpdateToastTitle: {
    id: 'contestation_update.success',
  },
  addJom: {
    id: 'legal_proceeding_page.action.create_jom',
  },
  addJomAppeal: {
    id: 'legal_proceeding_page.action.create_jom_appeal',
  },
  unvalidatedClaim: {
    id: 'claim.not_validated',
  },
  unvalidatedVictimsOrPa: {
    id: 'claim.with_unvalidated_victim_pa',
  },
  confirm: {
    id: 'court_manager_legal_proceedings_page.expert_report.decision.confirm',
  },
  cancel: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.refusal_popin.cancel',
  },
  appealMultiple: {
    id: 'decision_dialog.action_appeal',
  },
  judiciaryDocumentUpdate: {
    id:
      'legal_proceeding_page.judgement_add.civil_party.civil_party_recap.judiciary_document_update',
  },
  judiciaryDocument: {
    id:
      'legal_proceeding_page.judgement_add.civil_party.civil_party_recap.judiciary_document',
  },
  expertise: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.expertise.form.expertise',
  },
  updateTitle: {
    id: 'general.title.update',
  },
  assignmentDialogAssignMultipleLawyers: {
    id: 'assignment_dialog.assign_multiple_lawyers',
  },
  lawyerFirmReferenceWarningMessage: {
    id: 'legal_proceeding_page.update_firm_reference_dialog_warning_message',
  },
  lawyerFirmReferenceFeeNoteWarningMessage: {
    id:
      'legal_proceeding_page.update_firm_reference_dialog_warning_fee_note_message',
  },
  creatorTitle: {
    id: 'legal_proceeding_page.update_firm_reference_lawyer_name',
  },
  reasonField: {
    id: 'legal_proceeding_page.judgement_on_merits.reason',
  },
  assignmentLawyerWarning: {
    id: 'legal_proceeding_page.judgement_on_merits.assignment_warning',
  },
  generateFeeNote: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.generateFeeNote',
  },
  hearingDateError: {
    id: 'civil_proceeding_modal.basic_information.date_hearing_field.error',
  },
  updateJom: { id: 'legal_proceeding_page.judgement_on_merits.update' },
  updatedStepSuccessMessage: {
    id:
      'court_manager_legal_proceedings_page.step.modification_dialog.success_message',
  },
  updateJudiciaryProcess: {
    id: 'legal_proceeding_page.judiciary_process.update',
  },
  courtFileNumberError: {
    id: 'legal_proceeding_page.number_field.error',
  },
  updatedByTitle: {
    id: 'judiciary_process_recap_updated_by',
  },
  expertReportNotValidated: {
    id: 'legal_proceeding_page.judgement_on_merits_expert_report_warning',
  },
  invalidDate: {
    id: 'preopening_page.invalid_date',
  },
  expertReportNotExist: {
    id:
      'legal_proceeding_page.judgement_on_merits_expert_report_not_exist_warning',
  },
  invoiceNumberField: {
    id: 'invoice.dialog_info.field_invoice_number',
  },
  invoiceDateField: {
    id: 'invoice.dialog_info.field_invoice_date',
  },
  invoiceReceptionDateField: {
    id: 'invoice.dialog_info.field_invoice_reception_date',
  },
  civilJudgementRadioLabel: {
    id: 'legal_proceeding_page.judgement_on_merits.civil_judgement',
  },
  formRejectionRadioLabel: {
    id: 'legal_proceeding_page.judgement_on_merits.form_rejection',
  },
  substantiveRejectionRadioLabel: {
    id: 'legal_proceeding_page.judgement_on_merits.substantive_rejection',
  },
  dialogInfoSubTitle: {
    id: 'invoice.dialog_info.sub_title',
  },
  userNotValidWarning: {
    id: 'restricted_user_warning.title',
  },
  expertReportAlert: {
    id: 'judgement_with_compensation.alert.title',
  },
  civilRequestLabelTitle: {
    id: 'legal_proceeding_page.civil_request',
  },
  invalid: { id: 'validate.required_field' },
  expertReportWithoutDecision: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.expertise_report_alert',
  },
  victimExcludedFromCoverageWarningMessage: {
    id: 'victim.excluded_from_coverage_warning_message',
  },
  archiveJudgementSubTitle: {
    id:
      'court_manager_legal_proceedings_page.archive_judgement.content_message',
  },
  archiveJudgementTitle: {
    id:
      'court_manager_legal_proceedings_page.archive_judgement_on_the_merits.title',
  },
  archiveSuccessToast: {
    id:
      'court_manager_legal_proceedings_page.archive_judgement.success_message',
  },
  archiveReasonFieldError: {
    id:
      'court_manager_legal_proceedings_page.archive_judgement_on_the_merits.error_field',
  },
  FeeNoteTitle: {
    id: 'side_bar.fee_note',
  },
  transactionTabTitle: {
    id: 'transaction.legal_procedding.title',
  },
  intervenantName: {
    id: 'invoice.dialog_info.intervenant.name',
  },
  errorInvoiceDateIntervenant: {
    id: 'invoice.dialog_info.limit_invoice_date.intervenant.error',
  },
});
